import React, { useState } from 'react'
import { Layout, Input, Menu, Button, Drawer } from 'antd'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { 
  SearchOutlined, 
  BookOutlined, 
  HomeOutlined,
  MenuOutlined,
  SettingOutlined
} from '@ant-design/icons'
import './Header.css'

const { Header: AntHeader } = Layout
const { Search } = Input

function Header() {
  const navigate = useNavigate()
  const location = useLocation()
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false)

  const handleSearch = (value) => {
    if (value.trim()) {
      navigate(`/search?q=${encodeURIComponent(value.trim())}`)
    }
  }

  const menuItems = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: <Link to="/">首页</Link>,
    },
    {
      key: '/books',
      icon: <BookOutlined />,
      label: <Link to="/books">书籍</Link>,
    },
    {
      key: '/admin',
      icon: <SettingOutlined />,
      label: <Link to="/admin">管理</Link>,
    },
  ]

  return (
    <AntHeader className="site-header">
      <div className="header-content">
        {/* Logo */}
        <Link to="/" className="logo">
          <BookOutlined className="logo-icon" />
          <span className="logo-text">五千年文库</span>
        </Link>

        {/* 搜索框 */}
        <div className="search-container">
          <Search
            placeholder="搜索古代文献内容..."
            allowClear
            enterButton={<SearchOutlined />}
            size="large"
            onSearch={handleSearch}
            className="search-input"
          />
        </div>

        {/* 桌面导航菜单 */}
        <Menu
          mode="horizontal"
          selectedKeys={[location.pathname]}
          items={menuItems}
          className="desktop-menu"
        />

        {/* 移动端菜单按钮 */}
        <Button
          type="text"
          icon={<MenuOutlined />}
          onClick={() => setMobileMenuVisible(true)}
          className="mobile-menu-button"
        />

        {/* 移动端抽屉菜单 */}
        <Drawer
          title="导航菜单"
          placement="right"
          onClose={() => setMobileMenuVisible(false)}
          open={mobileMenuVisible}
          className="mobile-drawer"
        >
          <Menu
            mode="vertical"
            selectedKeys={[location.pathname]}
            items={menuItems}
            onClick={() => setMobileMenuVisible(false)}
          />
        </Drawer>
      </div>
    </AntHeader>
  )
}

export default Header